import React from "react";
import './Footer.css'

const Footer = (props) => {
    return (
        <div className={"fixed-bottom footer footer-" + props.currentPage}/>
    );
}

export default Footer;